@if (batch$ | async; as batch) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ batch: batch, frm: mainFrm }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button mat-dialog-close="">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ batch: batch, frm: mainFrm }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <form #mainFrm="ngForm" class="flex">
      <elder-single-pane-wrapper>
        <elder-pane-header>
          <elder-pane-title>{{ 'batches.detail' | translate }}</elder-pane-title>
          <elder-pane-actions class="layout-row gap-sm">
            @for (segment of getSegments(batch); track segment) {
              <button mat-stroked-button (click)="onPreviewBatchLabels(batch.id, segment)">
                <mat-icon>preview</mat-icon>
                <span>
                  {{ 'labels.preview' | translate
                  }}{{ displaySegment(segment, getSegments(batch).length) }}
                </span>
              </button>
            }
            <button mat-stroked-button (click)="onPreviewItemLabels(batch.id)">
              <mat-icon>preview</mat-icon>
              <span>{{ 'labels.items' | translate }}</span>
            </button>
            <button mat-stroked-button (click)="onPreviewPieceLabels(batch.id)">
              <mat-icon>preview</mat-icon>
              <span>{{ 'labels.piece' | translate }}</span>
            </button>
            <button mat-stroked-button (click)="onPreviewProdList(batch.id)">
              <mat-icon>assignment</mat-icon>
              <span>{{ 'orders.prod.list.title' | translate }}</span>
            </button>
            <button
              mat-stroked-button
              color="accent"
              (click)="resetTransferLock()"
              [disabled]="!resetEnabled(getSegments(batch))"
              [matTooltip]="getRelevantLock(getSegments(batch)) | date: 'medium'"
            >
              <mat-icon>usb</mat-icon>
              <span>{{ 'workBatches.resetTransferLock' | translate }}</span>
            </button>
            @if (
              batch?.state === WorkBatchState.PREVIEW || batch?.state === WorkBatchState.PREPARED
            ) {
              <button mat-stroked-button color="accent" (click)="abortBatch($event)">
                {{ 'actions.cancel' | translate }}
              </button>
            }
            @if (
              batch?.state === WorkBatchState.PROCESSING ||
              batch?.state === WorkBatchState.COMPLETED
            ) {
              <button mat-stroked-button color="warn" (click)="forceAbortBatch($event)">
                {{ 'actions.force-abort' | translate }}
              </button>
            }
          </elder-pane-actions>
        </elder-pane-header>
        <elder-pane-content>
          <div class="flex layout-col">
            <div class="flex-none layout-row place-center-center gap-sm my-lg">
              <mat-form-field elderFormFieldLabel>
                <mat-label>{{ 'context.number' | translate }}</mat-label>
                <input matInput name="id" readonly [value]="batch.number" />
              </mat-form-field>
              <mat-form-field elderFormFieldLabel>
                <mat-label>{{ 'context.state' | translate }}</mat-label>
                <input
                  matInput
                  name="id"
                  readonly
                  [value]="'WorkBatchState.' + batch.state | translate"
                />
              </mat-form-field>
              @if (isPackageSharingEnabled()) {
                <mat-slide-toggle
                  class="flex-none"
                  name="packageSharingScope"
                  [checked]="isShared(batch)"
                  disabled
                >
                  <div class="layout-row place-center-center mr-lg">
                    {{ 'packaging.batchPackageSharing.title' | translate }}
                  </div>
                </mat-slide-toggle>
              }
              <app-work-batch-line style="width: 100%" [batch]="batch"></app-work-batch-line>
            </div>
            <div class="flex layout-col">
              <app-work-item-table
                class="flex"
                [allowEdit]="batch.state !== WorkBatchState.COMPLETED"
                [workBatch]="batch"
                (itemDeleteRequested)="deleteItemsFromBatch($event)"
              >
              </app-work-item-table>
            </div>
          </div>
        </elder-pane-content>
      </elder-single-pane-wrapper>
    </form>
  </div>
}

<ng-template #header let-batch="batch" let-frm="frm">
  <elder-header
    [header]="('batches.batch' | translate) + ' ' + batch.number"
    [subheader]="'ID: ' + batch.id"
  >
  </elder-header>

  <span class="flex"></span>

  <!--  <button mat-icon-button-->
  <!--          [disabled]="!frm.form.valid">-->
  <!--    <mat-icon>save</mat-icon>-->
  <!--  </button>-->
</ng-template>
